// @flow

export type PermissionSet = $ReadOnlyArray<string>;

export const anyMatch = (
  required?: PermissionSet,
  provided: PermissionSet,
): boolean => !required || required.some((perm) => provided.includes(perm));

export const allMatch = (
  required?: PermissionSet,
  provided: PermissionSet,
): boolean => !required || required.every((perm) => provided.includes(perm));
